import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { MemberService } from '../../../core/members/member.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MemberTokenType } from '@app/shared/types/member_token_type';
import { first } from 'rxjs/operators';
import { SettingsService } from '@app/core/settings/settings.service';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { LoyaltyClubHeaderComponent } from '@app/shared/components/loyalty-club-header/loyalty-club-header.component';
import { TranslatePipe } from '@ngx-translate/core';
import { PasswordComponent } from '@app/shared/components/password/password.component';
import { AsyncPipe } from '@angular/common';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';
import { IdentifierType } from '@app/core/_models/member-interface';
import { AlertComponent } from '@app/shared/components/alert/alert.component';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  imports: [
    TopNavbarComponent,
    LoyaltyClubHeaderComponent,
    TranslatePipe,
    ReactiveFormsModule,
    PasswordComponent,
    AsyncPipe,
    LoyaltyClubFooterComponent,
    FormsModule,
    AlertComponent,
  ],
})
export class RecoverPasswordComponent {
  public setPasswordError = false;
  public isTokenCorrect: boolean | undefined;
  public hasSetPasswordError: boolean;
  public isPasswordChanged = false;
  public isSubmitted = false;
  public isGaleriaDominikanskaActive$ = this.settingsService.isGaleriaDominikanska();

  public form = this.formBuilder.group({
    password: '',
  });

  private email: string | null;
  private token: string | null;

  constructor(private formBuilder: UntypedFormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private memberService: MemberService,
              private settingsService: SettingsService) {
    this.route.queryParamMap.pipe(first()).subscribe((paramMap) => this.onParamsReceived(paramMap));
  }

  public onFormSubmit(): void {
    this.isSubmitted = true;
    this.hasSetPasswordError = false;

    if (this.form.invalid) {
      this.form.controls.password.updateValueAndValidity();
      return;
    }

    this.memberService.setPassword(this.email, this.token, this.form.get('password')?.value).subscribe({
      next: () => {
        this.isPasswordChanged = true;
      },
      error: () => this.hasSetPasswordError = true,
    });
  }

  public gotoLoginPage(): void {
    this.router.navigate(['..'],
      { relativeTo: this.route, replaceUrl: true, queryParams: { signup: false, email: this.email } });
  }

  private onParamsReceived(paramMap: ParamMap): void {
    this.email = paramMap.get('email');
    this.token = paramMap.get('token');

    this.verifyToken();
  }

  private verifyToken(): void {
    this.memberService.verifyToken(
      this.email?.replace(/\+/gi, '%2B'),
      MemberTokenType.PasswordReset,
      this.token,
      IdentifierType.EMAIL,
    ).subscribe(
      (isValid) => this.isTokenCorrect = isValid,
      () => this.isTokenCorrect = false,
    );
  }
}
